
import { defineComponent, PropType, toRef, watch, ref } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import SectionDetail from "@/views/form/views/SectionDetail.vue";
import { IFormSections } from "@/interfaces/iForm";

export default defineComponent({
  name: "form-section-modal",
  components: { VZModal, SectionDetail },
  emits: ["close-detail"],
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: { type: Object as PropType<IFormSections>, required: true },
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const sectionData = toRef(props, "data");
    const section = ref<IFormSections>();
    const close = () => {
      emit("close-detail");
    };
    watch(sectionData, (newVal) => {
      section.value = newVal;
    });

    return {
      t,
      close,
      section,
    };
  },
});
